import { graphql } from "gql.tada";
import { ListItemFragment } from "@queries/fragments/ListItemFragment";

export const ListSectionMoreById = graphql(
  `
    query ListSectionMoreById(
      $locale: String
      $preview: Boolean
      $id: String!
      $skip: Int
    ) {
      listSection(id: $id, preview: $preview, locale: $locale) {
        _id
        viewMoreText
        itemsCollection(skip: $skip, limit: 5) {
          total
          items {
            ...ListItemFragment
          }
        }
      }
    }
  `,
  [ListItemFragment]
);
